<template>
  <div>
    <div class="w-full pb-4 xl:pb-6">
      <Navigation :step="1" />

      <div class="w-full viewport-gutter">
        <div class="container">
          <div class="text-sm xl:text-lg">
            <h1 class="pb-2 text-lg font-bold leading-tight xl:text-4xl">
              {{ $t('pages.home.title') }}
            </h1>
            <p class="leading-tight">
              {{ $t('pages.home.subtitle') }}
            </p>
            <p class="pt-3 leading-tight text-gray-900">
              {{ $t('pages.home.multi_voucher_text', { maxVouchers }) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Form />
  </div>
</template>

<script lang="ts">
import Home from '~psp-pages/base/home/home.ts'

import Navigation from '~app/psp/lufthansa/navigation.vue'
import Form from './form.vue'

export default Home.extend({
  components: {
    Navigation,
    Form,
  },
})
</script>
